import notifyError from '@/lib/notify-error';
import notifySuccess from '@/lib/notify-success';
import {
  findAccount, createAccount, updateAccount, updateAccountRole,
} from '@/services/account';
import Router from '@/router';

const usersGetters = {
  editItem(st) {
    return st.editItem;
  },
  roles() {
    return [
      { name: 'Administrador', text: 'admin', value: 1 },
      { name: 'Operador', text: 'operador', value: 2 },
      { name: 'Pesquisador', text: 'pesquisador', value: 3 },
    ];
  },
  education() {
    return [
      'Ensino Fundamental',
      'Ensino Medio',
      'Ensino Superior',
      'Ensino Fundamental Incompleto',
      'Ensino Medio Incompleto',
      'Ensino Superior Incompleto',
    ];
  },
  loading(st) {
    return st.loading;
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setEditItem(state, item) {
    state.editItem = item;
  },
  setOriginalRole(state, role) {
    state.originalRole = role;
  },
  patchEditItem(state, patch) {
    state.editItem = {
      ...state.editItem,
      ...patch,
    };
  },
};

const actions = {
  afterRouteUpdate({ dispatch }, to) {
    if (to.params.id) {
      dispatch('loadAccount', to.params.id);
    }
  },
  loadAccount({ commit }, id) {
    commit('setLoading', true);
    const settings = {
      include: 'role',
    };
    findAccount(id, settings)
      .then((account) => {
        account.editRole = account.role[0].id;
        commit('setOriginalRole', account.editRole);
        commit('setEditItem', account);
      })
      .catch(notifyError())
      .finally(() => {
        commit('setLoading', false);
      });
  },
  onEditChange({ commit }, event) {
    commit('patchEditItem', event);
  },
  onEditSave({ commit, state }, form) {
    if (!form.validate()) {
      notifyError('Campos incorretos');
      return false;
    }
    commit('setLoading', true);
    const account = state.editItem;
    const role = account.editRole;
    delete account.editRole;
    account.email = account.email.trim().toLowerCase();
    if (account.id) {
      return updateAccount(account)
        .then(async (acc) => {
          if (state.originalRole !== role) {
            await updateAccountRole({ id: account.id, role });
          }
          commit('setEditItem', {});
          notifySuccess('Usuário editado com sucesso');
          Router.push({ name: 'Usuários listar' });
          return acc;
        })
        .catch((error) => {
          notifyError(error.message);
        })
        .finally(() => {
          commit('setLoading', false);
        });
    }
    return createAccount(account, role)
      .then((acc) => {
        commit('setEditItem', {});
        notifySuccess('Usuário adicionado com sucesso');
        Router.push({ name: 'Usuários listar' });
        return acc;
      })
      .catch((error) => {
        notifyError(error.message);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

export default {
  namespaced: true,
  state: {
    loading: false,
    editItem: {},
    originalRole: null,
  },
  mutations,
  getters: usersGetters,
  actions,
};
